<template>
  <div class="App">
    <div class="Content">
      <CLogin />
    </div>
    <div class="Imagenes">
      <sliderVue style="height: 100vh; border: none; margin: 0" />
    </div>
  </div>
</template>
<script>
import sliderVue from "../components/Login/slider.vue";
import CLogin from "../components/Login/CLogin.vue";

export default {
  name: "Login",
  components: { sliderVue, CLogin },
  data: () => ({}),
};
</script>
<style lang="css" scoped>
.App {
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
}
.Imagenes {
  width: 100%;
  height: 100%;
}

@media (max-width: 800px) {
  .App {
    grid-template-columns: auto;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url("../assets/imagen1.jpg");
    background-position: left; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    height: 100vh;
  }

  .Imagenes {
    display: none;
  }
}
</style>